import React from "react"

import { Skeleton } from "@be-miniapp/ui/components/ui/skeleton"
import { useEffectOnce } from "@be-miniapp/ui/hooks/use-effect-once"
import { cn } from "@be-miniapp/ui/lib/utils"

interface ProgressiveImageProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  placeholder?: string
  preload?: boolean
  sizeClassname?: string
}

const ProgressiveIcon = React.memo(
  ({
    preload,
    sizeClassname,

    ...props
  }: ProgressiveImageProps) => {
    const imageRef = React.useRef<HTMLImageElement>(null)
    const [src, setSrc] = React.useState<string | null>(
      preload ? props.src! : null
    )

    useEffectOnce(() => {
      if (!props.src) return
      const img = new Image()
      img.src = props.src!
      img.onload = () => {
        setSrc(props.src!)
      }
    })

    const szClassName = sizeClassname ?? "h-11 w-11"

    return (
      <div className={cn("relative", szClassName)}>
        <Skeleton
          className={cn(
            props.className,
            "absolute z-0 flex items-center justify-center rounded-full bg-[#E1F0FF]",
            szClassName
          )}
        ></Skeleton>

        {src ? (
          <img
            {...props}
            key={src}
            ref={imageRef}
            src={src!}
            className={cn("absolute top-0 left-0 z-10", szClassName)}
          />
        ) : null}
      </div>
    )
  }
)

export { ProgressiveIcon }
